module.exports = __webpack_public_path__ + "static/flags/ER-55deadb073a8462aeedd04c92763e2c5.gif";